import axios from 'axios';

export default axios.create({
	// baseURL: 'https://toggl.thms.be',
	baseURL: 'https://toggl-api.onrender.com/',
	// baseURL: 'http://localhost:4000',
	withCredentials: false,
});
